export default {
    order_loan: [
        {
            dataIndex: "audit_status",
            width: 80,
            title: "审批状态",
            scopedSlots: {
                customRender: "audit_status",
            },
        },
        {
            dataIndex: "object_no",
            width: 180,
            title: "放款单号",
        },
        {
            dataIndex: "order_no",
            width: 180,
            title: "订单号",
        },
        {
            dataIndex: "order.amount",
            width: 100,
            title: "订单总金额",
            customRender: (e) => `¥ ${e || "-"}`,
        },
        {
            dataIndex: "order.amount_loaned",
            width: 100,
            title: "已放款金额",
            customRender: (e) => `¥ ${e || "-"}`,
        },
        {
            dataIndex: "amount",
            width: 120,
            title: "本次放款金额",
            customRender: (e) => `¥ ${e || "-"}`,
        },
        {
            dataIndex: "type_text",
            width: 80,
            title: "款项类型",
        },
        {
            dataIndex: "member",
            width: 120,
            title: "收款客户",
            scopedSlots: {
                customRender: "member",
            },
        },
        {
            dataIndex: "user",
            width: 120,
            title: "申请人",
            scopedSlots: {
                customRender: "user",
            },
        },
        {
            dataIndex: "created_at",
            width: 140,
            title: "申请时间",
            customRender: (e) => (e ? moment(e * 1000).format("YYYY-MM-DD HH:mm") : ""),
        },
        {
            dataIndex: "remark",
            title: "备注",
            scopedSlots: {
                customRender: "remark",
            },
        },
        {
            dataIndex: "action",
            width: 130,
            align: "center",
            title: "操作",
            fixed: "right",
            scopedSlots: {
                customRender: "action",
            },
        },
    ],
    order_loan_deposit: [
        {
            dataIndex: "audit_status",
            width: 80,
            title: "审批状态",
            scopedSlots: {
                customRender: "audit_status",
            },
        },
        {
            dataIndex: "object_no",
            width: 180,
            title: "放款单号",
        },
        {
            dataIndex: "order_no",
            width: 180,
            title: "订单号",
        },
        {
            dataIndex: "order.amount",
            width: 120,
            title: "订单总金额",
            customRender: (e) => `¥ ${e || "-"}`,
        },
        {
            dataIndex: "amount",
            width: 120,
            title: "预付定金",
            customRender: (e) => `¥ ${e || "-"}`,
        },
        {
            dataIndex: "member",
            width: 120,
            title: "收款客户",
            scopedSlots: {
                customRender: "member",
            },
        },
        {
            dataIndex: "user",
            width: 120,
            title: "申请人",
            scopedSlots: {
                customRender: "user",
            },
        },
        {
            dataIndex: "screenshot",
            width: 80,
            title: "协议图片",
            scopedSlots: {
                customRender: "screenshot",
            },
        },
        {
            dataIndex: "created_at",
            width: 140,
            title: "申请时间",
            customRender: (e) => (e ? moment(e * 1000).format("YYYY-MM-DD HH:mm") : ""),
        },
        {
            dataIndex: "remark",
            title: "备注",
            scopedSlots: {
                customRender: "remark",
            },
        },
        {
            dataIndex: "action",
            width: 130,
            align: "center",
            title: "操作",
            fixed: "right",
            scopedSlots: {
                customRender: "action",
            },
        },
    ],
    balance_refund: [
        {
            dataIndex: "audit_status",
            width: 80,
            title: "审批状态",
            scopedSlots: {
                customRender: "audit_status",
            },
        },
        {
            dataIndex: "object_no",
            width: 180,
            title: "退款单号",
        },
        // {
        //     dataIndex: "amount_apply",
        //     width: 120,
        //     title: "申请金额",
        // },
        // {
        //     dataIndex: "amount_fee",
        //     width: 120,
        //     title: "退款费用/元",
        // },
        {
            dataIndex: "amount",
            width: 120,
            title: "退款金额",
            customRender: (e) => `¥ ${e || "-"}`,
        },
        {
            dataIndex: "member",
            width: 100,
            title: "退款客户",
            scopedSlots: {
                customRender: "member",
            },
        },
        {
            dataIndex: "user",
            width: 100,
            title: "申请人",
            scopedSlots: {
                customRender: "user",
            },
        },
        {
            dataIndex: "created_at",
            width: 140,
            title: "申请时间",
            customRender: (e) => (e ? moment(e * 1000).format("YYYY-MM-DD HH:mm") : ""),
        },
        {
            dataIndex: "memo",
            title: "备注",
        },
        {
            dataIndex: "action",
            width: 130,
            align: "center",
            title: "操作",
            fixed: "right",
            scopedSlots: {
                customRender: "action",
            },
        },
    ],
    recharge: [
        {
            dataIndex: "audit_status",
            width: 80,
            title: "审批状态",
            scopedSlots: {
                customRender: "audit_status",
            },
        },
        {
            dataIndex: "object_no",
            width: 180,
            title: "充值单号",
        },
        {
            dataIndex: "amount",
            width: 120,
            title: "充值金额",
            customRender: (e) => `¥ ${e || "-"}`,
        },
        {
            dataIndex: "member",
            width: 120,
            title: "充值客户",
            scopedSlots: {
                customRender: "member",
            },
        },
        {
            dataIndex: "user",
            width: 120,
            title: "申请人",
            scopedSlots: {
                customRender: "user",
            },
        },
        {
            dataIndex: "screenshot",
            width: 80,
            title: "截图凭证",
            scopedSlots: {
                customRender: "screenshot",
            },
        },
        {
            dataIndex: "memo",
            title: "备注",
            scopedSlots: {
                customRender: "remark",
            },
        },
        {
            dataIndex: "action",
            width: 130,
            align: "center",
            title: "操作",
            fixed: "right",
            scopedSlots: {
                customRender: "action",
            },
        },
    ],
};
